import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const LoanamortAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label("Loanaccountno"),
		period: yup.number().required().label("Period"),
		paydate: yup.string().required().label("Paydate"),
		payment: yup.number().required().label("Payment"),
		current_balance: yup.number().required().label("Current Balance"),
		interest: yup.number().required().label("Interest"),
		principal: yup.number().required().label("Principal"),
		paid: yup.string().nullable().label("Paid"),
		alerted: yup.number().nullable().label("Alerted"),
		od_yn: yup.number().nullable().label("Od Yn"),
		trxnid: yup.string().nullable().label("Trxnid"),
		merchanttrxnrefid: yup.string().nullable().label("Merchanttrxnrefid"),
		req_status: yup.string().nullable().label("Req Status"),
		userid: yup.number().nullable().label("Userid")
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		period: '', 
		paydate: new Date(), 
		payment: '', 
		current_balance: '', 
		interest: '', 
		principal: '', 
		paid: '', 
		alerted: '', 
		od_yn: '', 
		trxnid: '', 
		merchanttrxnrefid: '', 
		req_status: '', 
		userid: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/loanamort`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="LoanamortAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Transaction Schedule"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loanaccountno *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/loanaccountno_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="loanaccountno"     optionLabel="label" optionValue="value" value={formik.values.loanaccountno} onChange={formik.handleChange} options={response} label="Loanaccountno"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.loanaccountno)}   />
                                                    <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Period *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="period"  onChange={formik.handleChange}  value={formik.values.period}   label="Period" type="number" placeholder="Enter Period"  min={0}  step="any"    className={inputClassName(formik?.errors?.period)} />
                                                <ErrorMessage name="period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paydate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="paydate" value={formik.values.paydate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.paydate)}        />
                                                <ErrorMessage name="paydate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Payment *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="payment"  onChange={formik.handleChange}  value={formik.values.payment}   label="Payment" type="number" placeholder="Enter Payment"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.payment)} />
                                                <ErrorMessage name="payment" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Current Balance *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="current_balance"  onChange={formik.handleChange}  value={formik.values.current_balance}   label="Current Balance" type="number" placeholder="Enter Current Balance"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.current_balance)} />
                                                <ErrorMessage name="current_balance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Interest *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interest"  onChange={formik.handleChange}  value={formik.values.interest}   label="Interest" type="number" placeholder="Enter Interest"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interest)} />
                                                <ErrorMessage name="interest" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Principal *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principal"  onChange={formik.handleChange}  value={formik.values.principal}   label="Principal" type="number" placeholder="Enter Principal"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.principal)} />
                                                <ErrorMessage name="principal" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paid"  onChange={formik.handleChange}  value={formik.values.paid}   label="Paid" type="text" placeholder="Enter Paid"        className={inputClassName(formik?.errors?.paid)} />
                                                <ErrorMessage name="paid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Alerted 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="alerted"  onChange={formik.handleChange}  value={formik.values.alerted}   label="Alerted" type="number" placeholder="Enter Alerted"  min={0}  step="any"    className={inputClassName(formik?.errors?.alerted)} />
                                                <ErrorMessage name="alerted" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Od Yn 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="od_yn"  onChange={formik.handleChange}  value={formik.values.od_yn}   label="Od Yn" type="number" placeholder="Enter Od Yn"  min={0}  step="any"    className={inputClassName(formik?.errors?.od_yn)} />
                                                <ErrorMessage name="od_yn" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Trxnid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="trxnid"  onChange={formik.handleChange}  value={formik.values.trxnid}   label="Trxnid" type="text" placeholder="Enter Trxnid"        className={inputClassName(formik?.errors?.trxnid)} />
                                                <ErrorMessage name="trxnid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Merchanttrxnrefid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="merchanttrxnrefid"  onChange={formik.handleChange}  value={formik.values.merchanttrxnrefid}   label="Merchanttrxnrefid" type="text" placeholder="Enter Merchanttrxnrefid"        className={inputClassName(formik?.errors?.merchanttrxnrefid)} />
                                                <ErrorMessage name="merchanttrxnrefid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Req Status 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="req_status"  onChange={formik.handleChange}  value={formik.values.req_status}   label="Req Status" type="text" placeholder="Enter Req Status"        className={inputClassName(formik?.errors?.req_status)} />
                                                <ErrorMessage name="req_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label="Userid" type="number" placeholder="Enter Userid"  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
LoanamortAddPage.defaultProps = {
	primaryKey: 'amortid',
	pageName: 'loanamort',
	apiPath: 'loanamort/add',
	routeName: 'loanamortadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default LoanamortAddPage;
